import { useCallback } from "react";
import useApi from "../api";
import { UpsertProcessingRequestPackaging } from "./types";

const useProcessingRequestPackagingApi = () => {
  const baseurl = "/processing_request_packagings";

  const api = useApi();

  const createRequestPackaging = useCallback(
    async (p: UpsertProcessingRequestPackaging) => {
      const data = await api.post<UpsertProcessingRequestPackaging, string>(baseurl, p);
      api.mutateCache([`/processing_requests/${p.requestId}/labels_packagings`]);
      return data;
    },
    [api]
  );

  const updateRequestPackaging = useCallback(
    async (p: UpsertProcessingRequestPackaging) => {
      const data = await api.put<UpsertProcessingRequestPackaging>(baseurl, p);
      api.mutateCache([`/processing_requests/${p.requestId}/labels_packagings`]);
      return data;
    },
    [api]
  );

  const deleteRequestPackaging = useCallback(
    async (processingRequestID: number, packagingID: string) => {
      const data = await api.del(`${baseurl}/${processingRequestID}?packagingID=${packagingID}`);
      api.mutateCache([`/processing_requests/${processingRequestID}/labels_packagings`]);
      return data;
    },
    [api]
  );

  return {
    createRequestPackaging,
    updateRequestPackaging,
    deleteRequestPackaging,
  };
};

export default useProcessingRequestPackagingApi;
